import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

import Component from 'gia/Component'

export default class PhotoswipeComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      
      //scrollGallery els
      scrollWrapper: null, //check
      arrowRight: null, //check
      arrowLeft: null, //check
      photos: [], //check
      
      //swiper els
      pswpThumbnails: null, //check
      pswpThumbnailsWrapper: null, //check
      pswpThumbnailsNext: null, //check
      pswpThumbnailsPrev: null, //check
      
      //pswp els
      pswp: null, //check
      
      button: null, //check

      items: null
    }
    
    this.galleryScrollPositionX = 0;
    this.galleryMaxScrollPosition = 0;
    this.interacted = false;
    
    this.gallery = null;
    this.swiper = null;
    if (this.ref.items) {
      this.items = JSON.parse(this.ref.items.innerText);
    }
  }
  

  
  initSwiper() {
    const vm = this;
    //swiper
    const swiperConfig = {
      slidesPerView: 'auto',
      loopedSlides: 7,
      centeredSlides: true,
      spaceBetween: 0,
      threshold: 25,
      loop: true,
      navigation: {
        nextEl: vm.ref.pswpThumbnailsNext,
        prevEl: vm.ref.pswpThumbnailsPrev
      },
    }
    this.swiper = new Swiper(this.ref.pswpThumbnails, swiperConfig);
  }
  
  resetSwiper() {
    this.swiper.destroy();
    this.initSwiper();
  }
  
  openPhotoSwipe(index = null) {
    return function () {
      const vm = this;
      // possible options here: https://photoswipe.com/documentation/options.html
      const options = {
        timeToIdle: 9e9,
        timeToIdleOutside: 9e9,
        closeEl: true,
        bgOpacity: 0.85,
        captionEl: true,
        fullscreenEl: true,
        zoomEl: true,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        history: false,
        closeOnScroll: false
      };
      
      if (index) {
        options.index = parseInt(index, 10);
      }
      this.swiper.slideToLoop(parseInt(index, 10));
      
      // Initializes PhotoSwipe
      this.gallery = new PhotoSwipe(this.ref.pswp, PhotoSwipeUI_Default, this.items, options);
      this.gallery.init();
      
      this.gallery.listen('close', () => {
        this.element.classList.remove('pswp-open');
        this.resetSwiper();
      });
      
      this.gallery.listen('afterChange', function () {
        vm.swiper.slideToLoop(this.getCurrentIndex());
      });
      
      this.swiper.on('slideChange', function () {
        if (vm.gallery && this.realIndex != vm.gallery.getCurrentIndex()) {
          vm.gallery.goTo(parseInt(this.realIndex, 10));
        }
      });
      
      const thumbnails = this.swiper.slides;
      for (const thumb of thumbnails) {
        thumb.addEventListener('click', function () {
          const ix = this.dataset.index;
          //move swiper to index
          vm.swiper.slideToLoop(ix);
          // //move pswp to index
          vm.gallery.goTo(parseInt(ix, 10));
        })
      }
      
      
      //animate thumbnails in
      vm.element.classList.add('pswp-open');
    }
  }
  
  scrollInteraction(e) {
    this.galleryScrollPositionX = e.srcElement.scrollLeft;
    
    const startBuffer = window.innerWidth * 0.25;
    const endBuffer = window.innerWidth * 1.25;
    this.interacted = true;
    
    //if scrollpositionX less than 200, add at start
    //remove left shadow
    if (this.galleryScrollPositionX < startBuffer) {
      this.element.classList.remove('shadow-left');
    }
    //if scrollpositionX greater than 200, remove at start
    //remove bouncy arrow and show left shadow
    if (this.galleryScrollPositionX > startBuffer) {
      this.element.classList.add('shadow-left');
    }
    //if maxscrollX - 200 < scrollpositionX, add at end
    //remove right shadow
    if ((this.galleryMaxScrollPosition - this.galleryScrollPositionX) < endBuffer) {
      this.element.classList.remove('shadow-right');
    }
    //if maxscrollX - 200 > scrollpositionX, remove at end
    //add right shadow
    if ((this.galleryMaxScrollPosition - this.galleryScrollPositionX) > endBuffer) {
      this.element.classList.add('shadow-right');
    }
  }
  
  scrollRight() {
    return function () {
      let distance = window.innerWidth;
      if (this.ref.scrollWrapper.scrollLeft + distance > this.galleryMaxScrollPosition) {
        this.ref.scrollWrapper.scrollLeft = this.galleryMaxScrollPosition;
      }
      else {
        this.ref.scrollWrapper.scrollLeft += distance;
      }
    }
  }
  
  scrollLeft() {
    return function () {
      let distance = window.innerWidth;
      if (this.ref.scrollWrapper.scrollLeft - distance < 0) {
        this.ref.scrollWrapper.scrollLeft = 0;
      }
      else {
        this.ref.scrollWrapper.scrollLeft -= distance;
      }
    }
  }
  
  getScrollerWidth() {
    return function () {
      this.galleryMaxScrollPosition = this.ref.scrollWrapper.scrollWidth - window.innerWidth;
    }
  }
  
  mount() {
    this.initSwiper();
    //photoswipe
    this.ref.button.addEventListener('click', this.openPhotoSwipe(0).bind(this));
    const photos = this.ref.photos;
    for (const p of photos) {
      const ix = p.dataset.index;
      p.addEventListener('click', this.openPhotoSwipe(ix).bind(this))
    }

    this.galleryMaxScrollPosition = this.ref.scrollWrapper.scrollWidth - window.innerWidth;
    const diff = this.galleryMaxScrollPosition - window.innerWidth;
    if(diff < 0) {
      this.element.classList.remove('shadow-left');
      this.element.classList.remove('shadow-right');
    }
    window.addEventListener('resize', this.getScrollerWidth().bind(this));

    this.ref.scrollWrapper.addEventListener('scroll', (event) => this.scrollInteraction(event))
    
    this.ref.arrowRight.addEventListener('click', this.scrollRight().bind(this));
    this.ref.arrowLeft.addEventListener('click', this.scrollLeft().bind(this));
    
  }
}